import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["id", "value", "aria-describedby", "aria-invalid", "required"];
const _hoisted_2 = {
    key: 0,
    value: "",
    disabled: ""
};
const _hoisted_3 = ["value"];
export default /*@__PURE__*/ _defineComponent({
    __name: 'BaseSelect',
    props: {
        modelValue: {},
        options: {},
        id: { default: undefined },
        placeholder: { default: "" },
        ariaDescribedby: { default: undefined },
        invalid: { type: Boolean, default: false },
        required: { type: Boolean, default: false }
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        // SYNC: see ../../_SYNC.md.
        const emit = __emit;
        function onChange(event) {
            emit("update:modelValue", event.target.value);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("select", {
                id: __props.id,
                class: _normalizeClass(["df-select", { 'df-select--error': __props.invalid }]),
                value: __props.modelValue,
                "aria-describedby": __props.ariaDescribedby,
                "aria-invalid": __props.invalid ? true : undefined,
                required: __props.required,
                onChange: onChange
            }, [
                (__props.placeholder)
                    ? (_openBlock(), _createElementBlock("option", _hoisted_2, _toDisplayString(__props.placeholder), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (opt) => {
                    return (_openBlock(), _createElementBlock("option", {
                        key: opt.value,
                        value: opt.value
                    }, _toDisplayString(opt.label), 9 /* TEXT, PROPS */, _hoisted_3));
                }), 128 /* KEYED_FRAGMENT */))
            ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_1));
        };
    }
});
